import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { MiddlwareService } from 'src/app/core/services/middleware.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { c1, c16, TabNames } from 'src/app/core/services/constants';
import { MenuButton, Tab } from 'src/app/core/services/interface';
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Router } from '@angular/router';
import { BuilderService } from 'src/app/sharedservices/builder.service';

@Component({
  selector: 'app-tabbuttonstylesearch',
  templateUrl: './tabbuttonstylesearch.component.html',
  styleUrls: ['./tabbuttonstylesearch.component.scss']
})

/**
 * Contacts domain-list component
 */
export class TabButtonStyleSearchComponent implements OnInit, OnDestroy {
  // bread crumb items
  breadCrumbItems: Array<{}>;
  component_ref: any;
  inputData: any;
  input: any;
  tabNames = TabNames;
  currentTabID: any;
  previousTabID: any;
  current_tab: Tab;
  bg_color: string;
  isAndroid: boolean;
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;
  colors: any;

  sortedTabList: any;
  tabList: any;
  currentMenuSubscription: any;
  colorsComponentSubscription: any;
  schemeChangeSubscription: any;

  viewSubscription: any;
  mode = "top";
  data: any={};
  @Input() button_id: any;
  @Input() menuGroup: any;
  currentButton: MenuButton;
  rowList: any;
  sortedRowList: any;
  buttonList: any;
  sortedButtonList: any;
  defaultButton: any;
  sortedMenuList: any;
  menuList: any;
  menu: any;
  defaultRow: any;
  max_buttons: number;
  module: any;
  divider = false;

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    private load: LoaderService,
    private ref: ChangeDetectorRef,
    private router: Router,
    public indexDBService: IndexDBService,
    public builderService: BuilderService

  ) {

  }
  albums = [];
  albums_dark=[];
  albums_light=[];
  albums_light_ios=[];
  albums_dark_ios=[];
  tab: Tab;
  tab_style: string ="02";

  ngOnInit() {

    this.component_ref = this.mdw.makeRef(16);
    this.breadCrumbItems = [{ label: 'UI Elements' }, { label: 'Lightbox', active: true }];

      this.albums_light = [
      { id: 'search-01', style:'01',  src: 'https://nandbox.com/wp-content/uploads/2025/03/default-list_AN_100_190-1.webp', caption: "" },
      { id: 'search-02', style:'02',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-avatar_AN_100_190-1.webp', caption: "" },
      { id: 'search-03', style:'03',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-icons_AN_100_190-1.webp', caption: "" },
      { id: 'search-04', style:'04',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image-_AN_100_190-1.webp', caption: "" },
      { id: 'search-05', style:'05',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image_AN_100_190-1.webp', caption: "" },
      { id: 'search-06', style:'06',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_1_light.webp', caption: "" },
      { id: 'search-07', style:'07',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image_AN_100_190-1.webp', caption: "" },
      { id: 'search-08', style:'08',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_4_light.webp', caption: "" },
      { id: 'search-09', style:'09',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_3_light.webp', caption: "" },
      { id: 'search-10', style:'10',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_2_light.webp', caption: "" },
    ]

    this.albums_dark = [
      { id: 'search-01', style:'01',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_default-list_AN_100_190-1.webp', caption: "" },
      { id: 'search-02', style:'02',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-avatar-_AN_100_190-1.webp', caption: "" },
      { id: 'search-03', style:'03',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-icons_AN_100_190-1.webp', caption: "" },
      { id: 'search-04', style:'04',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-image-_AN_100_190-1.webp', caption: "" },
      { id: 'search-05', style:'05',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-leading-media_AN_100_190-1.webp', caption: "" },
      { id: 'search-06', style:'06',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_1_dark.webp', caption: "" },
      { id: 'search-07', style:'07',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image_AN_100_190-1.webp', caption: "" },
      { id: 'search-08', style:'08',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_4_dark.webp', caption: "" },
      { id: 'search-09', style:'09',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_3_dark.webp', caption: "" },
      { id: 'search-10', style:'10',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_2_dark.webp', caption: "" },
    ]

    this.albums_light_ios = [
      { id: 'search-01', style:'01',  src: 'https://nandbox.com/wp-content/uploads/2025/03/default-list_iOS_100_190-1.webp', caption: "" },
      { id: 'search-02', style:'02',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-circular-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-03', style:'03',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-icons_iOS_100_190-1.webp', caption: "" },
      { id: 'search-04', style:'04',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-rounded-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-05', style:'05',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-fill-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-06', style:'06',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_1_light.webp', caption: "" },
      { id: 'search-07', style:'07',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image_AN_100_190-1.webp', caption: "" },
      { id: 'search-08', style:'08',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_4_light.webp', caption: "" },
      { id: 'search-09', style:'09',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_3_light.webp', caption: "" },
      { id: 'search-10', style:'10',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_2_light.webp', caption: "" },
    ]

    this.albums_dark_ios = [
      { id: 'search-01', style:'01',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_default-list_iOS_100_190-1.webp', caption: "" },
      { id: 'search-02', style:'02',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-circular-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-03', style:'03',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-icons_iOS_100_190-1.webp', caption: "" },
      { id: 'search-04', style:'04',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-rounded-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-05', style:'05',  src: 'https://nandbox.com/wp-content/uploads/2025/03/Dark_List-with-fill-image_iOS_100_190-1.webp', caption: "" },
      { id: 'search-06', style:'06',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_1_dark.webp', caption: "" },
      { id: 'search-07', style:'07',  src: 'https://nandbox.com/wp-content/uploads/2025/03/List-with-image_AN_100_190-1.webp', caption: "" },
      { id: 'search-08', style:'08',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_4_dark.webp', caption: "" },
      { id: 'search-09', style:'09',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_3_dark.webp', caption: "" },
      { id: 'search-10', style:'10',  src: 'https://nandbox.com/wp-content/uploads/2026/04/List_2_dark.webp', caption: "" },
    ]
    this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
    this.light = localStorage.getItem("mode")[15]==c16.LIGHT? true:false
    this.albums= this.isAndroid? this.light? this.albums_light: this.albums_dark: this.light? this.albums_light_ios: this.albums_dark_ios

   this.colorsComponentSubscription = this.mdw.colorsComponentContainer$.subscribe(
      (data) => {
        if (data  && data.color_schema  && data.color_schema_ios && data.light !=null) {
          this.colors = data;
          this.light = data.light
          if (this.tab){
            this.initialize(this.tab)
          }
        }
      })

      this.schemeChangeSubscription = this.mdw.schemeChangeContainer$.subscribe(
        (data) => {
          if (this.tab){
            this.initialize(this.tab)
          }
          }
      );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe((data) => {
      if (data && !data.fromButton && data["tab"].module == "query") {
        this.data = data;
        this.tab = data["tab"];
        if (this.tab){
          this.initialize(this.tab)
        }
      }
    });

    if (this.menuGroup){
     const tab = this.indexDBService.getItem("tab", this.menuGroup);
     tab.onsuccess = (event) => {
       if (tab.result) {
        this.tab = tab.result;
        this.data['tab']=this.tab
        this.tab_style = this.tab.style.style_id;
       if (this.tab && this.tab.style && this.tab.style.divider && this.tab.style.divider == 1){
        this.divider = true;
        }
      }
         }
      }


  }

  initialize(tab){
    this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
    this.light = localStorage.getItem("mode")[15]==c16.LIGHT? true:false
    this.albums= this.isAndroid? this.light? this.albums_light: this.albums_dark: this.light? this.albums_light_ios: this.albums_dark_ios

    if (tab && tab.style && tab.style.style_id) {
      this.tab_style = this.tab.style.style_id;
    } else {
      this.tab_style = "02"
    }

    this.divider = false;
    if (tab && tab.style && tab.style.divider && tab.style.divider == 1){
      this.divider = true;
    }

    if (this.colors &&  this.colors.color_schema) {
      this.color_schema = this.light ? this.colors.color_schema.schemes.light : this.colors.color_schema.schemes.dark;
      this.color_schema_ios = this.light ? this.colors.color_schema_ios.schemes.light : this.colors.color_schema_ios.schemes.dark
      this.bg_color = this.isAndroid ? this.color_schema.surface : this.color_schema_ios.surface
    }
  }

  sortRows(rows: any[]) {
    return rows.sort((a, b) => Number(a.row_order) - Number(b.row_order));
  }
  sortButtons(buttons: any[]) {
    return buttons.sort(
      (a, b) => Number(a.button_order) - Number(b.button_order)
    );
  }

  open(index: number): void {
    // open lightbox
    if (this.data && this.data['tab']){
    this.tab_style = this.albums[index].style
    this.data["tab"]['style']['style_id'] = this.tab_style;
    if(this.divider){
      this.data["tab"]['style']['divider'] = 1;
    } else {
      this.data["tab"]['style']['divider'] = 0;
    }

    /// update tab
    let tabdata = {
      tab: this.data["tab"],
      mode: this.data["mode"],
    };
    this.mdw.changeTab(tabdata, this.mode, false);
    if (this.data["sortedRowList"] && this.data["sortedRowList"].length >0){
      let row_id = this.data["sortedRowList"][0].row_id
      let sortedMenuList = this.data["sortedMenuList"]

      let Menudata = {
        tab: { module: "splash" },
        mode: this.data["mode"],
        menu: this.data["menu"],
        row: this.data["sortedRowList"][0],  // each page one menu, one row , one button.
        button: this.data["sortedButtonList"][row_id][0],
      };

      sortedMenuList.forEach((menu) => {
        if (menu) {
          menu.menu_verion = this.mdw.makeRef(16);
          const response = this.indexDBService.updateItem("menu", menu);
          this.data["menuList"][menu.menu_id].menu_version = menu.menu_version;
          const rows = this.indexDBService.getItemList("row", "menu", menu.menu_id);
          rows.onsuccess = (event) => {
            if (rows.result) {
              let row = rows.result[0];
              row.row_version = this.mdw.makeRef(16);
              const response = this.indexDBService.updateItem("row", row);

              const buttons = this.indexDBService.getItemList("button", "row", row.row_id);
              buttons.onsuccess = (event) => {
                if (buttons.result) {
                  let button = buttons.result[0];
                  button.button_version = this.mdw.makeRef(16);
                  const response = this.indexDBService.updateItem("button", button);
                }
              }
            }
          }
        }
      })
      this.data["sortedMenuList"] = sortedMenuList;
      this.mdw.changeTab(Menudata, this.mode, true);
      this.mdw._currentMenuContainer.next(this.data); // to update menupages
    }
  }
}

  get setImageBg() {
    if (this.bg_color) {
      return { background: this.bg_color };
    } else {
      return { background: "unset" };
    }
  }

  toggleDivider(){
    if (this.data && this.data['tab']){
    this.divider = !this.divider;
    this.data["tab"]['style']['style_id'] = this.tab_style;
    if(this.divider){
      this.data["tab"]['style']['divider'] = 1;
    } else {
      this.data["tab"]['style']['divider'] = 0;
    }

    /// update tab
    let tabdata = {
      tab: this.data["tab"],
      mode: this.data["mode"],
    };
    this.mdw.changeTab(tabdata, this.mode, false);
  }
}

  ngOnDestroy(): void {
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }

    if (this.schemeChangeSubscription) {
      this.schemeChangeSubscription.unsubscribe();
    }
  }
}
